import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_ENROLLMENT_PERIOD_BY_ID } from 'api/queries/enrollmentService';
import { EnrollmentPeriod } from 'types/enrollmentService';
import { isEnrollmentPeriodNotEditable } from '../checklists-helpers/ChecklistHelper';

const useImmutablePeriod = (periodId: string): boolean => {
  const [getEnrollmentPeriodQuery, { data }] = useLazyQuery<{
    getEnrollmentPeriod: EnrollmentPeriod;
  }>(GET_ENROLLMENT_PERIOD_BY_ID, {
    fetchPolicy: 'no-cache',
    variables: { periodId },
    nextFetchPolicy: 'cache-first',
  });

  useEffect(() => {
    void getEnrollmentPeriodQuery();
  }, [getEnrollmentPeriodQuery]);

  return data?.getEnrollmentPeriod.stage ? isEnrollmentPeriodNotEditable(data?.getEnrollmentPeriod.stage) : false;
};

export default useImmutablePeriod;
